import React from "react";
import App from "./js/App";
import {render} from "react-dom";

const __svg__ = { path: './assets/svg/**/*.svg', name: 'static/media/svg-symbols.svg' };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

render(<App />, document.querySelector('#root'));



// WEBPACK FOOTER //
// ./src/index.js